import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: #0E1F1F;
  border-radius: 16px;
  padding: 24px;
  width: 90%;
  max-width: 480px;
  border: 2px solid #284640;
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const ModalHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
`;

const ModalTitle = styled.h2`
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 20px;
  color: #FFFFFF;
  margin: 0;
`;

const CloseButton = styled.button`
  background: transparent;
  border: none;
  color: #838D90;
  font-size: 24px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 32px;
  height: 32px;
  
  &:hover {
    color: #FFFFFF;
  }
`;

const TableContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  
  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 4px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color-primary);
    border-radius: 3px;
    border: 1px solid #0e1f1f;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: #1e9e6b;
  }

  scrollbar-width: thin;
  scrollbar-color: var(--color-primary) transparent;
`;

const SizeTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  color: #FFFFFF;
  font-family: 'Ubuntu', sans-serif;
`;

const TableHeader = styled.th`
  padding: 12px;
  text-align: center;
  border-bottom: 1px solid #284640;
  font-weight: 500;
  font-size: 16px;
  color: #24BA7D;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: rgba(40, 70, 64, 0.2);
  }
  
  &:hover {
    background-color: rgba(40, 70, 64, 0.4);
  }
`;

const TableCell = styled.td`
  padding: 10px;
  text-align: center;
  border-bottom: 1px solid #284640;
  font-size: 14px;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 16px;
`;

const Button = styled.button`
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-family: 'Ubuntu', sans-serif;
  font-weight: 500;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: #24BA7D;
  color: #FFFFFF;
  
  &:hover {
    background-color: #1E9A66;
  }
`;

// Тип для карты размеров
type SizeMap = {
  [key: string]: [number, number, number];
};

interface SizeChartModalProps {
  isOpen: boolean;
  onClose: () => void;
  sizeMap: SizeMap;
}

const SizeChartModal: React.FC<SizeChartModalProps> = ({
  isOpen,
  onClose,
  sizeMap
}) => {
  if (!isOpen) return null;

  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalTitle>Таблица размеров</ModalTitle>
          <CloseButton onClick={onClose}>×</CloseButton>
        </ModalHeader>
        
        <TableContainer>
          <SizeTable>
            <thead>
              <tr>
                <TableHeader>US</TableHeader>
                <TableHeader>UK</TableHeader>
                <TableHeader>EU</TableHeader>
              </tr>
            </thead>
            <tbody>
              {Object.keys(sizeMap)
                .sort((a, b) => parseFloat(a) - parseFloat(b))
                .map((usSize) => (
                  <TableRow key={usSize}>
                    <TableCell>{usSize}</TableCell>
                    <TableCell>{sizeMap[usSize][1]}</TableCell>
                    <TableCell>{sizeMap[usSize][2]}</TableCell>
                  </TableRow>
                ))}
            </tbody>
          </SizeTable>
        </TableContainer>
        
        <ButtonContainer>
          <Button onClick={onClose}>
            Закрыть
          </Button>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SizeChartModal;